
import { Tooltip } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { line, scaleLinear } from 'd3';
import React, { memo } from 'react';

const Pointer = ({
	width = 12.5,
	head = (0.8 * 250) / 2 - 5,
	tail = 5,
	value = -5,
	tooltip = '',
	center = { x: 125, y: 135 },
	minAngle,
	maxAngle,
	fill,
	disabled
}) => {
	const pointerLine = line()([
		[width / 2, 0],
		[0, -head],
		[-(width / 2), 0],
		[0, tail],
		[width / 2, 0]
	]);
	const valueScale = scaleLinear().domain([0, 1]).range([minAngle, maxAngle]);
	const pointerValue = valueScale(value);
	const theme = useTheme()
	return (
		<Tooltip
			title={tooltip}
			disableFocusListener={!tooltip}
			disableTouchListener={!tooltip}
			disableHoverListener={!tooltip}
		>
			<g>
				<path
					className="gauge-pointer"
					d={pointerLine}
					transform={`translate(${center.x}, ${center.y}) rotate(${pointerValue})`}
					fill={fill || theme.palette.text.primary}
					opacity={disabled ? 0.3 : undefined}
					style={{
						transition: 'all 0.25s 0.25s'
					}}
				/>
				<circle cx={center.x} cy={center.y} r={width / 2} fill={fill || theme.palette.text.primary}/>
			</g>
		</Tooltip>
	);
};

export default memo(Pointer);
